<template>
  <div class="radar-map">
    <sky-charts
      ref="chart"
      :apiConf="apiConf"
      :queryCondition="condition"
      :beforeRender="beforeRender"
      :config="chartConfig"
      :legendPosition="legendPosition"
      :showTitle="showTitle"
      :showShadow="showShadow"
      :chartData="chartData"
      :extend="extend"
    >
      <slot name="average" slot="header"></slot>
    </sky-charts>
  </div>
</template>

<script>
export default {
  props: {
    apiConf: {},
    condition: {},
    extend: {},
    chartConfig: {},
    chartData: {},
    beforeRender: {
      type: Function
    },
    showTitle: {
      type: Boolean
    },
    showShadow: {
      type: Boolean
    },
    legendPosition: {
      type: String,
      default: "bottom"
    }
  },
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss" scoped></style>
